module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/work/components/work-main.component.html
// module id = ./src/app/modules/work/components/work-main.component.html
// module chunks = main